import { render, staticRenderFns } from "./community-list.vue?vue&type=template&id=3d979c83&scoped=true"
import script from "./community-list.vue?vue&type=script&lang=js"
export * from "./community-list.vue?vue&type=script&lang=js"
import style0 from "./community-list.vue?vue&type=style&index=0&id=3d979c83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d979c83",
  null
  
)

export default component.exports